/** Preset payment terms (KCG team examples + common trade terms). */
export const PAYMENT_TERMS_OPTIONS = [
  '100% in CAD',
  '100% in USD',
  '100% in ZAR',
  '100% in EUR',
  '5 days before arrival',
  '7 days before arrival',
  '30 days after arrival',
  '14 days after arrival',
  '60 days after arrival',
  'Net 30 days',
  'Net 60 days',
  '50% advance, 50% on arrival',
  '50% advance, 50% before arrival',
  'On delivery',
  'Cash against documents (CAD)',
  'Letter of credit (L/C)',
  'Documents against payment (D/P)',
  'Documents against acceptance (D/A)',
] as const

export function filterPaymentTermsOptions(query: string): string[] {
  const q = query.trim().toLowerCase()
  if (!q) return [...PAYMENT_TERMS_OPTIONS]
  return PAYMENT_TERMS_OPTIONS.filter((option) => option.toLowerCase().includes(q))
}
